import CompanyParametersTab from 'src/components/pages/Company/CompanyPage/CompanyParametersTab/CompanyParametersTab';

export default CompanyParametersTab;
